import { Section, SectionHead } from "./SectionPrimitives";

export default function CitationSection({ citation_status }) {
  const cs = citation_status || {};
  const totalDirs = cs.total_count || 12;
  const accurate = cs.accurate_count || 0;
  const inaccurateCount = cs.inaccurate_count || 0;
  const missing = cs.missing_count || (totalDirs - accurate - inaccurateCount);
  const healthPct = Math.round((accurate / totalDirs) * 100);
  const rawDirs = cs.directories || [
    { name: "Google Business", status: "accurate" },
    { name: "Yelp", status: "accurate" },
    { name: "Facebook", status: "inaccurate" },
    { name: "Apple Maps", status: "missing" },
    { name: "Bing Places", status: "accurate" },
    { name: "Yellow Pages", status: "missing" },
    { name: "BBB", status: "missing" },
    { name: "Foursquare", status: "inaccurate" },
  ];
  const dirs = rawDirs.map(d => ({
    name: d.name,
    status: d.status === "missing" ? "missing" : "listed",
    accurate: d.status === "accurate",
    source: d.source || "estimated",
  }));

  const citationDataSource = (() => {
    return rawDirs.some(d => d.source === "live") ? "live" : "estimated";
  })();

  return (
    <Section id="citations">
      <SectionHead num="03" title="Citation & Directory Health" subtitle="Your business listings across top directories — inconsistencies confuse Google and kill rankings." dataSource={citationDataSource} />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(140px,1fr))", gap: 12, marginBottom: 20 }}>
        <div style={{ background: "#D1FAE5", border: "1px solid #A7F3D0", borderRadius: 10, padding: "16px", textAlign: "center" }}>
          <p style={{ fontSize: "clamp(24px, 4vw, 32px)", fontWeight: 900, color: "#0D6E3F" }}>{accurate}</p>
          <p style={{ fontSize: 12, fontWeight: 700, color: "#0D6E3F" }}>Accurate</p>
        </div>
        <div style={{ background: "#FEF3C7", border: "1px solid #FDE68A", borderRadius: 10, padding: "16px", textAlign: "center" }}>
          <p style={{ fontSize: "clamp(24px, 4vw, 32px)", fontWeight: 900, color: "#92400E" }}>{inaccurateCount}</p>
          <p style={{ fontSize: 12, fontWeight: 700, color: "#92400E" }}>Inaccurate</p>
        </div>
        <div style={{ background: "#FEE2E2", border: "1px solid #FECACA", borderRadius: 10, padding: "16px", textAlign: "center" }}>
          <p style={{ fontSize: "clamp(24px, 4vw, 32px)", fontWeight: 900, color: "#B91C1C" }}>{missing}</p>
          <p style={{ fontSize: 12, fontWeight: 700, color: "#B91C1C" }}>Missing</p>
        </div>
        <div style={{ background: "#F9FAFB", border: "1px solid #E5E7EB", borderRadius: 10, padding: "16px", textAlign: "center" }}>
          <p style={{ fontSize: "clamp(24px, 4vw, 32px)", fontWeight: 900, color: "#111827" }}>{healthPct}%</p>
          <p style={{ fontSize: 12, fontWeight: 700, color: "#4B5563" }}>Health Score</p>
        </div>
      </div>
      <div className="report-scroll-table">
        <table style={{ borderCollapse: "collapse", fontSize: 13 }}>
          <thead><tr style={{ background: "#F8FAFC" }}>
            <th style={{ padding: "10px 14px", textAlign: "left", fontWeight: 700, color: "#374151", fontSize: 12, borderBottom: "2px solid #E2E8F0", whiteSpace: "nowrap" }}>Directory</th>
            <th style={{ padding: "10px 14px", textAlign: "center", fontWeight: 700, color: "#374151", fontSize: 12, borderBottom: "2px solid #E2E8F0", whiteSpace: "nowrap" }}>Status</th>
            <th style={{ padding: "10px 14px", textAlign: "center", fontWeight: 700, color: "#374151", fontSize: 12, borderBottom: "2px solid #E2E8F0", whiteSpace: "nowrap" }}>Accuracy</th>
          </tr></thead>
          <tbody>
            {dirs.map((d, i) => (
              <tr key={i} className="tbl-row" style={{ borderBottom: "1px solid #F3F4F6" }}>
                <td style={{ padding: "10px 16px", fontWeight: 600, color: "#111827" }}>
                  {d.name}
                  {d.source === "estimated" && <span style={{ fontSize: 9, color: "#9CA3AF", marginLeft: 6, fontWeight: 400, fontStyle: "italic" }}>est.</span>}
                </td>
                <td style={{ padding: "10px 16px", textAlign: "center" }}>
                  <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 4, background: d.status === "listed" ? "#D1FAE5" : "#FEE2E2", color: d.status === "listed" ? "#0D6E3F" : "#B91C1C" }}>
                    {d.status === "listed" ? "LISTED" : "MISSING"}
                  </span>
                </td>
                <td style={{ padding: "10px 16px", textAlign: "center" }}>
                  {d.status === "listed" ? (
                    <span style={{ fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 4, background: d.accurate ? "#D1FAE5" : "#FEF3C7", color: d.accurate ? "#0D6E3F" : "#92400E" }}>
                      {d.accurate ? "ACCURATE" : "MISMATCH"}
                    </span>
                  ) : <span style={{ color: "#6B7280", fontSize: 12 }}>—</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {missing > 0 && (
        <div style={{ background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 10, padding: "14px 18px", marginTop: 14 }}>
          <p style={{ fontSize: 14, fontWeight: 700, color: "#991B1B" }}>You're missing from {missing} directories</p>
          <p style={{ fontSize: 13, color: "#4B5563", marginTop: 4, lineHeight: 1.6 }}>Each missing listing is a lost opportunity for Google to verify your business. Competitors with complete citations rank higher.</p>
        </div>
      )}
    </Section>
  );
}
